import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppCoreService } from 'src/app/services/app-core.service';
import { AWBService } from 'src/app/services/operations/awb.service';
import { ManifestService } from 'src/app/services/operations/manifest.service';

@Component({
  selector: 'app-update-status',
  templateUrl: './update-status.component.html',
  styleUrls: ['./update-status.component.scss']
})

export class UpdateStatusComponent implements OnInit{
  updateStatusForm: FormGroup;
  @Input() public cellData: any;
  statusList: any;
  isFormSubmitted = false;

  awbList: any[] = [];
  availableAwbList: any[] = [];
  selectedSCId: number;
  useEnterKey: true;
  constructor(
    private appCoreService: AppCoreService,
    private manifestService: ManifestService,
    private awbService: AWBService,
    private _fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private ngxLoaderService: NgxUiLoaderService
  ) {

  }

  ngOnInit(): void {
    // throw new Error('Method not implemented.');
    this.updateStatusForm = this._fb.group({
      ddlAwb: [null, Validators.required],
      // ddlStatus: [null, Validators.required],
      // txtActionDate : [null, Validators.required],
      txtCustomStatus: [null, Validators.required]
    });

    // console.log('this.cellData', this.cellData);
    this.useEnterKey = this.appCoreService.GetUserData().metaInfo.tabbasedtemplate;
    if (this.cellData) {
      // this.getAllStatuses();
      // this.awbNumber = this.cellData.awbnumber;
      this.getAwbInfo(this.cellData.id);
    }
    this.appCoreService.SelectedServiceCenter().subscribe((val) => {
      this.selectedSCId = val;
    });

  }

  getAwbInfo(manifestId) {
    try {
      this.ngxLoaderService.start();
      this.manifestService.GetById(manifestId).subscribe(res => {
        if (res && res?.success) {
          this.ngxLoaderService.stop();
          const awbdetails = res.data[0]?.awbdetails;
          this.availableAwbList = awbdetails?.filter(x => x.parentawbnumber != null && x.parentawbnumber !== '')
          .map(x => ({ parentawbnumber: x.parentawbnumber, awbnumber: x.awbnumber }));
        } else if (res && !res.success) {
          this.ngxLoaderService.stop();
        }
      })
    } catch (e) {
      console.error(e);
    }
  }

  onSaveClick(): void {
    this.isFormSubmitted = true;
    if (this.updateStatusForm.valid) {
      const requestObj = {
        // id: this.podId,
        generatedfromid: this.selectedSCId,
        awbnumbers: this.updateStatusForm.get('ddlAwb')?.value,
        remark: this.updateStatusForm.get('txtCustomStatus').value,
        // actiondate: this.updateStatusForm.get('txtActionDate').value,
        source: 'manifest',
        // statusupdate: this.statusList.find(item => item.id === transationStatusId).name,
      }
      
      // console.log('requestObj', requestObj);
      this.ngxLoaderService.start();
      try {
        this.awbService.UpdateStatus(requestObj).subscribe(res => {
          if (res?.success) {
            this.ngxLoaderService.stop();
            // console.log(res);
            this.appCoreService.showMessage('Status updated successsfully', 'Success', 'success');
            this.resetFrom();
            this.activeModal.close('Save Click');

          } else if (res && !res.sucess) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.message, 'Error', 'error');
          }
        })
      } catch (error) {
        this.ngxLoaderService.stop();
      }
    }
  }

  resetFrom(): void {
    this.isFormSubmitted = false;
    this.updateStatusForm.reset();
  }
}
